import { Theme } from './theme'

const fontWeights: Theme['fontWeights'] = {
  thin: 100,
  hairline: 200,
  light: 300,
  normal: 400,
  medium: 500,
  semibold: 600,
  bold: 700,
  extrabold: 800,
  black: 900,
}

export default fontWeights
